import React, { useState, useEffect } from "react";
import config from "../../../Common/Configurations/APIConfig";
import apiService from "../../../Common/Configurations/APIService";
import Header from "../../../Common/Layout/Header";
import AccountTabs from "../../AllTabs/AccountTabs";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../../Common/Layout/DeleteAlert";

const initialFieldValues = {
  chequeId: "00000000-0000-0000-0000-000000000000",
  userId: "00000000-0000-0000-0000-000000000000",
  companyBankAccountId: "",
  invoiceId: "",
  chequeNumber: "",
  issueDate: new Date().toISOString().split("T")[0],
  clearedDate: "",
  amount: "",
  remarks: "",
  status: "",
};

const Cheque = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [invoices, setInvoices] = useState([]);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };

  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setAddShow(true);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETCHEQUEBYUSER}/${user?.id}`,
      pageSize,
      pageNumber
    );
    console.log("Cheque Data:", res);
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };

  const GetBankAccounts = async () => {
    const res = await apiService.getAll(
      `${config.GETAllBANKACCOUNTS}/${user.cid}`
    );
    console.log("Bank Accounts:", res);
    setBankAccounts(res);
  };

  const GetInvoices = async () => {
    const res = await apiService.getAll(
      `${config.GETINVOICESBYCOMPANYID}/${user?.cid}`
    );
    setInvoices(res.data);
  };

  const GetLastPageData = () => {
    GetData(totalPages);
  };

  const GetFirstPageData = () => {
    GetData("1");
  };

  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en", { month: "short" }).toUpperCase();
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toUpperCase()) {
      case "ISSUED":
        return "badge bg-warning text-dark";
      case "CLEARED":
        return "badge bg-success";
      case "BOUNCED":
        return "badge bg-danger";
      case "PENDING":
        return "badge bg-info";
      default:
        return "badge bg-secondary";
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  const showEditDetails = (data) => {
    const formattedData = {
      ...data,
      companyBankAccountId: data.companyBankAccountId || data.bankAccountId,
      issueDate: data.issueDate
        ? data.issueDate.split("T")[0]
        : new Date().toISOString().split("T")[0],
      clearedDate: data.clearedDate ? data.clearedDate.split("T")[0] : "",
    };
    setRecordForEdit(formattedData);
    setValues(formattedData);
    setAddShow(true);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETECHEQUE, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.companyBankAccountId =
      values.companyBankAccountId === "" ? false : true;
    temp.invoiceId = values.invoiceId === "" ? false : true;
    temp.chequeNumber = values.chequeNumber === "" ? false : true;
    temp.issueDate = values.issueDate === "" ? false : true;
    temp.amount = values.amount === "" ? false : true;
    temp.status = values.status === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        chequeId: values.chequeId,
        userId: user?.id,
        companyBankAccountId: values.companyBankAccountId,
        invoiceId: values.invoiceId,
        chequeNumber: values.chequeNumber,
        issueDate: values.issueDate,
        clearedDate: values.clearedDate || null,
        amount: values.amount,
        remarks: values.remarks,
        status: values.status,
      };
      try {
        const isNew =
          formData.chequeId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATECHEQUE, formData);
        } else {
          await apiService.update(config.UPDATECHEQUE, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
      GetBankAccounts();
      GetInvoices();
    }
  }, [user, loading]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
       <Header User={user} activeSection="accounts" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <AccountTabs pageName="CHEQUE" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Cheque
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>S.No</th>
                          <th>Cheque No</th>
                          <th>Bank Account</th>
                          <th>Invoice No</th>
                          <th>Issue Date</th>
                          <th>Cleared Date</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.chequeId}>
                              <td>{index + 1 + (pageNumber - 1) * pageSize}</td>
                              <td>
                                <strong>{v.chequeNumber}</strong>
                              </td>
                              <td>
                                <div>
                                  <div className="fw-medium">{v.bankName}</div>
                                  <div className="text-muted small">
                                    A/C: {v.accountNumber}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-light text-dark">
                                  {v.invoiceNumber}
                                </span>
                              </td>
                              <td>
                                <span className="fw-medium">
                                  {formatDate(v.issueDate)}
                                </span>
                              </td>
                              <td>
                                <span className="fw-medium">
                                  {v.clearedDate
                                    ? formatDate(v.clearedDate)
                                    : "-"}
                                </span>
                              </td>
                              <td>
                                <span className="fw-bold">
                                  INR{parseFloat(v.amount).toFixed(2)}
                                </span>
                              </td>
                              <td>
                                <span className={getStatusColor(v.status)}>
                                  {v.status}
                                </span>
                              </td>
                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.chequeId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                        {lists.length === 0 && (
                          <tr>
                            <td colSpan="9" className="text-center py-4">
                              <div className="text-muted">
                                <i className="ri-inbox-line fs-1" />
                                <h5 className="mt-2">No cheques found</h5>
                                <p className="mb-0">
                                  Add your first cheque to get started
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" +
                          (data.previousPage === null ? " disabled" : "")
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" +
                          (data.nextPage === null ? " disabled" : "")
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {values.chequeId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Cheque
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="companyBankAccountId" className="form-label">
                    Bank Account
                  </label>
                  <select
                    name="companyBankAccountId"
                    value={values.companyBankAccountId}
                    onChange={handleInputChange}
                    className={
                      "form-control" + applyErrorClass("companyBankAccountId")
                    }
                  >
                    <option value="">Select Bank Account</option>
                    {bankAccounts.map((account) => (
                      <option
                        key={account.companyBankAccountId}
                        value={account.companyBankAccountId}
                      >
                        {account.bankName} - {account.accountNo} ({account.ifsc}
                        )
                      </option>
                    ))}
                  </select>
                  {errors.companyBankAccountId === false ? (
                    <div className="validationerror">
                      Please select bank account
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="invoiceId" className="form-label">
                    Invoice
                  </label>
                  <select
                    name="invoiceId"
                    value={values.invoiceId}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("invoiceId")}
                  >
                    <option value="">Select Invoice</option>
                    {invoices.map((invoice) => (
                      <option key={invoice.invoiceId} value={invoice.invoiceId}>
                        {invoice.invoiceNumber}
                      </option>
                    ))}
                  </select>
                  {errors.invoiceId === false ? (
                    <div className="validationerror">Please select invoice</div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="chequeNumber" className="form-label">
                    Cheque Number
                  </label>
                  <input
                    type="text"
                    value={values.chequeNumber}
                    name="chequeNumber"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("chequeNumber")}
                    placeholder="Please Enter Cheque Number"
                    maxLength={50}
                  />
                  {errors.chequeNumber === false ? (
                    <div className="validationerror">
                      Please enter cheque number
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="amount" className="form-label">
                    Amount
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={values.amount}
                    name="amount"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("amount")}
                    placeholder="Please Enter Amount"
                  />
                  {errors.amount === false ? (
                    <div className="validationerror">Please enter amount</div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="issueDate" className="form-label">
                    Issue Date
                  </label>
                  <input
                    type="date"
                    value={
                      values.issueDate || new Date().toISOString().split("T")[0]
                    }
                    name="issueDate"
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("issueDate")}
                    required
                  />
                  {errors.issueDate === false ? (
                    <div className="validationerror">
                      Please enter issue date
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="clearedDate" className="form-label">
                    Cleared Date
                  </label>
                  <input
                    type="date"
                    value={values.clearedDate || ""}
                    name="clearedDate"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    name="status"
                    value={values.status}
                    onChange={handleInputChange}
                    className={"form-control" + applyErrorClass("status")}
                  >
                    <option value="">Select Status</option>
                    <option value="Issued">Issued</option>
                    <option value="Cleared">Cleared</option>
                    <option value="Bounced">Bounced</option>
                    <option value="Pending">Pending</option>
                  </select>
                  {errors.status === false ? (
                    <div className="validationerror">Please select status</div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="remarks" className="form-label">
                    Remarks
                  </label>
                  <input
                    type="text"
                    value={values.remarks}
                    name="remarks"
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Please Enter Remarks"
                    maxLength={250}
                  />
                </div>
              </div>
              <Modal.Footer>
                <div className="hstack gap-2 justify-content-end">
                  {btnLoading === false ? (
                    <button type="submit" className="btn btn-primary">
                      {values.chequeId ===
                      "00000000-0000-0000-0000-000000000000"
                        ? "Submit"
                        : "Update"}
                    </button>
                  ) : (
                    <button type="submit" className="btn btn-primary" disabled>
                      Please wait...
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default Cheque;
